export function hasItems<T>(
  array: ReadonlyArray<T>
): array is [T, ...ReadonlyArray<T>] {
  return array.length > 0;
}
